/**
 * 定数の設定
 * 各コンポーネントではmixinとして呼び込む
 * なお、同名の定数値がすでに存在した場合、そちらが優先されるので注意
 */
var constMixin = {
  data: function () {
    return {
      awardTypes: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ],
      awardTypeNames: {
        1: '10選2019',
        2: '10選2018',
        3: '10選2017',
        4: '10選2016',
        5: '10選2015',
        6: '10選2014',
        7: '10選2013',
        8: '10選2012',
        9: '日本写真100景',
        10: '"My Precious" Photo Contest'
      },
      awardTypeCode: {
        1: 'Tcc10Sen2019',
        2: 'Tcc10Sen2018',
        3: 'Tcc10Sen2017',
        4: 'Tcc10Sen2016',
        5: 'Tcc10Sen2015',
        6: 'Tcc10Sen2014',
        7: 'Tcc10Sen2013',
        8: 'Tcc10Sen2012',
        9: 'Japan100Views',
        10: 'MyPrecious',
        99: 'blank'
      },
      prefecturesMap: {
        北海道: '北海道',
        青森県: '東北',
        岩手県: '東北',
        宮城県: '東北',
        秋田県: '東北',
        山形県: '東北',
        福島県: '東北',
        茨城県: '関東',
        栃木県: '関東',
        群馬県: '関東',
        埼玉県: '関東',
        千葉県: '関東',
        東京都: '関東',
        神奈川県: '関東',
        新潟県: '中部',
        富山県: '中部',
        石川県: '中部',
        福井県: '中部',
        山梨県: '中部',
        長野県: '中部',
        岐阜県: '中部',
        静岡県: '中部',
        愛知県: '中部',
        三重県: '近畿',
        滋賀県: '近畿',
        京都府: '近畿',
        大阪府: '近畿',
        兵庫県: '近畿',
        奈良県: '近畿',
        和歌山: '近畿',
        和歌山県: '近畿',
        鳥取県: '中国',
        島根県: '中国',
        岡山県: '中国',
        広島県: '中国',
        山口県: '中国',
        徳島県: '四国',
        香川県: '四国',
        愛媛県: '四国',
        高知県: '四国',
        福岡県: '九州',
        佐賀県: '九州',
        長崎県: '九州',
        熊本県: '九州',
        大分県: '九州',
        宮崎県: '九州',
        鹿児島県: '九州',
        沖縄県: '沖縄',
        'アメリカ カリフォルニア州': '海外'
      },
      linkUrl100Kei: 'https://japanphotospot.tokyocameraclub.com/?id=',
      spacerAwardTypeId: 99,
      spacerPageInitialIndex: 9000000
    }
  }
}

export default constMixin
